import { Children } from "react";

import Styles from './UI.module.scss';

export const HGap = () => <span className={Styles.horizontalGap} />
export const VGap = () => <div className={Styles.verticalGap} />

export const Button = (
	{ label, onClick, ...rest }
	: {
		label: React.ReactNode,
		onClick?: () => void,
	}
) => <button {...rest} onClick={onClick} className={Styles.button}>{label}</button>;

export const ButtonGroup: React.FC = ({ children }) =>
	<div className={Styles.buttonGroup}>
		{children}
	</div>;

export const LineInput = (
	{ value, onChange }
	: {
		value: string,
		onChange: (newValue: string) => void,
	}
) => <input type="text" className={Styles.lineInput}
	value={value}
	onChange={e => onChange(e.target.value)} />;


export const Modal: React.FC = (
	{ children }) =>
	<div className={Styles.modalFullScreen}>
		<div className={Styles.modalContent}>
			{children}
		</div>
	</div>;
